import { useState, useEffect } from 'react';
import carbonConfigService from 'src/services/carbonConfigService';
import { buildCarbonConstants } from 'src/utils/carbonFootprint';

// Resolves the effective carbon constants for a team so client-side calculations
// (e.g. the Environmental Impact chart) match what the backend uses. Falls back
// to the deployment default (env + built-in) while loading or on error.
const useTeamCarbonConfig = (teamId) => {
  const [constants, setConstants] = useState(() => buildCarbonConstants());
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!teamId) return undefined;

    let active = true;
    setIsLoading(true);
    setError(null);

    carbonConfigService
      .getTeamCarbonConfig(teamId)
      .then((response) => {
        if (!active) return;
        const resolved = response?.data?.resolved;
        // `resolved` is already shaped like CARBON_CONSTANTS; buildCarbonConstants
        // re-applies guards and fills any missing key from the default.
        setConstants(buildCarbonConstants(resolved || {}));
        setConfig(response?.data?.config || null);
      })
      .catch((err) => {
        if (!active) return;
        setError(err);
        setConstants(buildCarbonConstants()); // safe deployment default
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [teamId]);

  return { constants, config, isLoading, error };
};

export default useTeamCarbonConfig;
